import React from 'react';
import HeaderComponent from "../components/HeaderComponent";
import {connect} from "react-redux";

class HeaderContainer extends React.Component {

	render() {
		return this.props.inApp ? null :
			<div>
				<HeaderComponent languages={this.props.languages} currentLanguage={this.props.language} path={this.props.path} onLangSelect={(lang) => this.props.changeLanguage(lang)} onLogout={() => this.props.logout()}/>
			</div>
	}

}

export default connect(
	(state) => {
		return {
			path: state.router.location.pathname,
			inApp: state.browser.inApp,
			languages: state.language.languages,
			language: state.language.currentLanguage
		}
	},
	(dispatch) => {
		return {
			changeLanguage: (language) => {
				dispatch({
					type: 'CHANGE_LANGUAGE',
					language
				})
			},
			logout: () => {
				dispatch({
					type: 'LOGOUT'
				})
			}
		}
	}
)(HeaderContainer)